import { Component, Prop, Vue } from "vue-property-decorator";
import StepperHeader from "./parts/StepperHeader/index.vue";
import { StepList } from "./parts/StepperHeader/StepperHeader.component";

@Component({
  components: {
    StepperHeader,
  },
})
export default class StepperComponent extends Vue {
  @Prop({ default: StepList.asbestos })
  public currentStep!: StepList;

  @Prop({ default: [] })
  public steps!: string[];

  /**
   * Move to previous step
   */
  goBack(): void {
    this.currentStep--;
  }

  /**
   * Move to next step
   */
  goNext(): void {
    this.currentStep++;
  }

  /**
   * Check if the active step is step number X
   * @param step
   * @returns true
   */
  isActiveStep(step: StepList): boolean {
    return this.currentStep === step;
  }
}
